import React, { useState } from "react";
import { Download } from "lucide-react";

interface BackupCodesDisplayProps {
  codes: string[];
  onDone: () => void;
}

const BackupCodesDisplay: React.FC<BackupCodesDisplayProps> = ({ codes, onDone }) => {
  const [confirmed, setConfirmed] = useState(false);

  const handleDownload = () => {
    const blob = new Blob([codes.join("\n")], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "adrsta-backup-codes.txt";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-600">
        Save these backup codes somewhere safe. Each one can be used once to
        sign in if you lose access to your authenticator app. They won't be
        shown again.
      </p>
      <div className="grid grid-cols-2 gap-2 font-mono text-sm bg-gray-50 border border-gray-200 rounded-lg p-4">
        {codes.map((code) => (
          <div key={code}>{code}</div>
        ))}
      </div>
      <button
        type="button"
        onClick={handleDownload}
        className="flex items-center gap-2 px-4 py-2 text-sm rounded-lg font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
      >
        <Download className="w-4 h-4" />
        Download as .txt
      </button>
      <label className="flex items-start gap-2 text-sm text-gray-700">
        <input
          type="checkbox"
          checked={confirmed}
          onChange={(e) => setConfirmed(e.target.checked)}
          className="mt-0.5 w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
        />
        I've saved these codes somewhere safe
      </label>
      <button
        type="button"
        onClick={onDone}
        disabled={!confirmed}
        className="w-full px-4 py-2 rounded-lg font-medium bg-primary hover:bg-primary-dark text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Done
      </button>
    </div>
  );
};

export default BackupCodesDisplay;
